/* eslint react/jsx-filename-extension: 0 */

import React from 'react';
import ReactDOM from 'react-dom';
import ReactGA from 'react-ga';
import { connectRouter, routerMiddleware } from 'connected-react-router';
import 'babel-polyfill';
import 'formdata-polyfill';
import { createBrowserHistory } from 'history';
import ErrorBoundary from './utils/logger';


import './reset.css';
import './index.css';
import Root from './Root';
import registerServiceWorker from './registerServiceWorker';

import rootReducer from './redux/reducers';
import { configureStore } from './utils/redux';

const history = createBrowserHistory();
const store = configureStore(connectRouter(history)(rootReducer), {}, routerMiddleware(history));

ReactDOM.render(
  <ErrorBoundary>
    <Root store={store} history={history} />
  </ErrorBoundary>,
  document.getElementById('root'),
);
ReactGA.initialize('UA-72771286-8');
ReactGA.pageview(window.location.pathname + window.location.search);
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js